import { takeEvery, put } from 'redux-saga/effects';

import forgotPasswordActions from '../actionTypes/forgotPasswordActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { FORGOT_PASSWORD_URL } from '../routes';

function* forgotPassword({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: FORGOT_PASSWORD_URL,
      method: 'POST',
      data: payload,
    },
    successAction: forgotPasswordActions.forgotPasswordSuccess,
    failureAction: forgotPasswordActions.forgotPasswordFailed,
  });
}

export default function* watchUserForgotPassword() {
  yield takeEvery(forgotPasswordActions.forgotPassword, forgotPassword);
}
